module.exports = __webpack_public_path__ + "img/biaoyu-bac.6149905c.png";